import { Columns } from '@shared/interfaces/table/column-config';
import { MeterFrameDto } from '@app/api/nts';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { meterFrameStatusPartial } from '@shared/partials/meterframe-status.partial';
import { meterFrameTypePartial } from '@shared/partials/meterframe-type.partial';
import { networkPlacementPartial } from '@shared/partials/network-placement.partial';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const meterframeDetailsMasterdata: Columns<MeterFrameDto>[] = [
  meterFrameStatusPartial,
  meterFrameTypePartial,
  {
    title: 'meterFrame.unittype',
    key: 'unitType',
    hideIfNull: true,
    hideIf: (data) => (data?.meterFrameType ?? '').toString().toLowerCase() !== 'serial',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      chargingstation: 'meterFrame.unitTypeOptions.ChargingStation',
      heatpump: 'meterFrame.unitTypeOptions.HeatPump',
      batterysystem: 'meterFrame.unitTypeOptions.BatterySystem',
    }
  },
  {
    title: 'meterFrame.identification',
    key: 'identification'
  },
  {
    title: 'meterFrame.transformer',
    key: 'transformer'
  },
  {
    title: 'meterFrame.maximumPower',
    key: 'maximumPower',
  },
  {
    title: 'meterFrame.maximumPowerModified',
    key: 'maximumPowerModified',
    cellRenderer: DateCellComponent
  },
  {
    title: 'meterFrame.limitedGridAccess',
    key: 'limitedGridAccess',
  },
  {
    title: 'meterFrame.maximumCurrent',
    key: 'maximumCurrent',
  },
  networkPlacementPartial,
  {
    title: 'meterFrame.Date',
    key: 'connectionDate',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'meterFrame.description',
    key: 'description'
  },
];
